import React from 'react';

const {ChevronUp, ChevronDown, X} = polyphony.icons;

// TODO: left and right (place controls halfway up the sides of the div)
const Deleteable = React.forwardRef(({onDelete, onUp, onDown, upSvg, downSvg, children, ...props}, ref) => {
    let up_svg = React.cloneElement(upSvg ? upSvg : <ChevronUp />, {height: '100%', width: '100%'});
    let down_svg = React.cloneElement(downSvg ? downSvg : <ChevronDown />, {height: '100%', width: '100%'});
    let x_svg = React.cloneElement(<X />, {height: '100%', width: '100%', style: {padding: 3, boxSizing: 'border-box'}});
    return (
        <div {...props} ref={ref}>
            <div style={{display: 'flex', position: 'relative'}}>
                {children}
                <div key='xbutton' style={{background: 'black', height: 22, width: 22, position: 'absolute', top: -11, right: -11, fontSize: '2ex', borderRadius: 11, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={onDelete}>{x_svg}</div>
                {onUp && <div key='upbutton' style={{background: 'gray', height: 22, width: 22, position: 'absolute', top: -11, left: -11, fontSize: '2ex', borderRadius: 11, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', padding: 5, boxSizing: 'border-box'}} onClick={onUp}>{up_svg}</div>}
                {onDown && <div key='downbutton' style={{background: 'gray', height: 22, width: 22, position: 'absolute', bottom: -11, left: -11, fontSize: '2ex', borderRadius: 11, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', padding: 5, boxSizing: 'border-box'}} onClick={onDown}>{down_svg}</div>}
            </div>
        </div>
    );
});

export default Deleteable;

